

























































































































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import MailboxConnection from '@/components/Settings/MailboxConnection.vue';
import Alert from '@/components/Shared/Alert.vue';
import { AppModule } from '@/store/modules/app';

@Component({
  name: 'UserProfile',
  components: {
    MailboxConnection,
    Alert
  }
})
export default class UserProfile extends GiganautVue {
  get userProfile() {
    return AppModule.userProfile;
  }

  get avatarUrl() {
    if (!this.userProfile.avatar || !this.userProfile.agencyUserId) {
      return '';
    }
    return AppModule.currentAgencyContext.storageSharedBaseUrl +
      "/avatars/2/" + this.userProfile.agencyUserId + "/" + this.userProfile.avatar;
  }

  get avatarThumbnailUrl() {
    if (!this.userProfile.avatar || !this.userProfile.agencyUserId) {
      return '';
    }
    return AppModule.currentAgencyContext.storageSharedBaseUrl +
      "/avatars/2/" + this.userProfile.agencyUserId + "/resized-100/" + this.userProfile.avatar;
  }
}
